import {base, baseConfig} from "../Services/api";

export function create(obj) {
    const conf = {
        method: 'POST',
        body: JSON.stringify(obj),
        ...baseConfig
    };

    return fetch(`${base}reservations`, conf);
}

export function getRange(opts) {
  let url = new URL(`${base}reservations/range`);
  Object.keys(opts).forEach(key => url.searchParams.append(key, opts[key]));
  return fetch(url, baseConfig);
}

export function get() {
    return fetch(`${base}reservations`, baseConfig);
}

export function getOne(id) {
    return fetch(`${base}reservations/${id}`, baseConfig);
}

export function update(id, obj) {
    const conf = {
        method: 'PUT',
        body: JSON.stringify(obj),
        ...baseConfig
    };
    return fetch(`${base}reservations/${id}`,conf);
}
